<script>
export default {
  props: {
    campaignOverview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    postsByStatus() {
      if (!this.campaignOverview.posts_by_status) {
        return null
      }

      const postsByStatus = this.campaignOverview.posts_by_status

      return {
        series: [postsByStatus.nonsubmitted ?? 0, postsByStatus.draft ?? 0, postsByStatus.approved ?? 0, postsByStatus.published ?? 0],
        chartOptions: {
          tooltip: {
            y: {
              formatter: function (value) {
                return value;
              }
            }
          },
          chart: {
            type: 'donut',
          },
          labels: ['Not submitted', 'Draft', 'Approved', 'Published'],
          colors: ['#F46A6A', '#f1b44c', '#34c38f', '#50a5f1'],
          legend: {
            show: true,
          },
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            pie: {
              donut: {
                size: '70%',
                labels: {
                  show: true,
                  name: {
                    show: true,
                    fontSize: '22px',
                    fontFamily: 'sans-serif',
                    fontWeight: 400,
                    offsetY: 10,
                    formatter: function (val) {
                      return val
                    }
                  },
                  value: {
                    show: true,
                    fontSize: '22px',
                    // fontFamily: 'sans-serif',
                    fontWeight: 600,
                    offsetY: -28,
                    formatter: function (val) {
                      return val + '%';
                    }
                  },
                  total: {
                    show: true,
                    showAlways: true,
                    label: 'Total posts',
                    fontSize: '16px',
                    fontFamily: 'sans-serif',
                    fontWeight: 600,
                    color: '#adb5bd',
                    formatter: function (w) {
                      return w.config.series.reduce((a, b) => a + b, 0)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</script>

<template>
  <div class="card flex-fill">
    <div class="card-body">
      <div class="mb-2">
        <h4 class="card-title mb-4 d-inline">Posts</h4> <span class="text-muted font-size-12">- only from Signed agreements</span>
      </div>

      <div v-if="postsByStatus">
        <div>
          <apexchart
              class="apex-charts"
              dir="ltr"
              height="220"
              :series="postsByStatus.series"
              :options="postsByStatus.chartOptions"
          ></apexchart>
        </div>
      </div>
      <div v-else>
        <h1>N/A</h1>
      </div>
    </div>
  </div>
</template>
